<div
  #elementSize="hmElementSize"
  #sticker="dds-sticker"
  (onHidden)="onHidden()"
  [ddsSticker]="optionsList"
  [stickerMaxHeight]="400"
  [stickerIndent]="0"
  [stickerIsDisabled]="isDisabled"
  [stickerIsOutsideClick]="true"
  hmElementSize
  stickerPosition="bottom-left"
  [ngClass]="{
    'dds-select_error': !!errorMessage,
  }"
>
  <div *ngIf="label" class="dds-select__text-wrap">
    <label class="dds-select__title">
      {{ label }}
      <span *ngIf="isRequired" class="dds-required"></span>
    </label>
  </div>
  <dds-search
    #search
    (valueChanged)="onTermChanged($event)"
    (fieldCleared)="onClearField()"
    [disabled]="isDisabled"
    [isTrimValue]="true"
    [placeholder]="placeholder"
    [value]="term"
    [customClass]="isErrorRequired ? 'dds-select__search_error' : ''"
    size="md"
  >
  </dds-search>
  <span *ngIf="errorMessage" class="dds-select__error">{{ errorMessage }}</span>
</div>

<ng-template #optionsList>
  <div
    [ngStyle]="{ 'width.px': elementSize.width }"
    role="listbox"
    *ngIf="isOptionsAvailable"
  >
    <ng-container *ngIf="options$ | async as filteredOptions">
      <div
        *ngIf="filteredOptions.length !== 0"
        class="search-dropdown"
        hmInfiniteScroll
        (scrollEnd)="loadMore()"
        [scrollThreshold]="scrollThreshold"
        [scrollDebounce]="scrollDebounce"
        [preloadPercentage]="preloadPercentage"
      >
        <div class="dds-context-menu">
          <button
            (click)="onOptionSelected(option)"
            *ngFor="
              let option of filteredOptions
                | lazyLoad: itemsPerPage : currentPage
            "
            class="dds-context-menu-item"
            role="option"
          >
            <span class="dds-context-menu-item__text">
              <ng-container
                *ngTemplateOutlet="
                  optionTemplate;
                  context: { $implicit: option, searchTerm: term }
                "
              >
              </ng-container>
            </span>
          </button>

          <div
            *ngIf="hasMoreItemsFor(filteredOptions)"
            class="search-dropdown__loading"
          >
            <span class="dds-context-menu-item__text">Loading more...</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
